// overall store for entire orders subtree
export const getActiveOrdersType = (state) => state.orders.pageState.activeOrdersType;
export const getOrdersRoot = (state) => state.orders;
export const getOrderDetails = (state) => state.orders.details;
export const getOrderType = (state) => state.orders.details.order.data.type;
export const getMonitoringOrderSnapshot = (state) => state.orders.snapshot;

// type-specific orders store
export const getOrdersTypeRoot = (state, orderType) => getOrdersRoot(state)[orderType];
export const getOrdersTypePagination = (state, orderType) => getOrdersTypeRoot(state, orderType).pagination;
export const getOrdersTypeSorting = (state, orderType) => getOrdersTypeRoot(state, orderType).sorting;

// form modal
export const getOrderCreationModalData = (state) => state.orders.createOrder;
